import React, { useState } from "react";
import { InputField } from "../../../../../components/controls/InputField";
import { ButtonControl } from "../../../../../components/controls/ButtonControl";
import "./chatInterface.scss";
import { trackEchoAIQuery } from "../../../../../utilities/analytics";

export default function ChatInputInterface() {
  const [question, setQuestion] = useState("");
  const [chatItems, setChatItems] = useState(() => {
    const savedChatItems = sessionStorage.getItem("virtualLibrarianChatItems");
    return savedChatItems ? JSON.parse(savedChatItems) : [];
  });

  const handleChatItemsUpdate = () => {
    setChatItems(
      JSON.parse(sessionStorage.getItem("virtualLibrarianChatItems")) ?? []
    );
  };

  window.addEventListener("virtualLibrarianChatItems", handleChatItemsUpdate);

  const handleSubmitQuestion = () => {
    if (!question.trim()) return;

    const sessionQueryNumber = chatItems.length + 1;
    trackEchoAIQuery('chat_followup', question.length, sessionQueryNumber);
    sessionStorage.setItem("virtualLibrarianVideoQuestion", question);
    window.dispatchEvent(new Event("virtualLibrarianQuestionSubmittedUpdated"));
    setQuestion("");
  };

  const handleClearChat = () => {
    window.dispatchEvent(new Event("virtualLibrarianClearChatUpdated"));
  };

  const handleOnChange = (value) => {
    setQuestion(value);
  };

  const handleOnKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmitQuestion();
    }
  };

  return (
    <div className="chat-input-interface">
      <div className="chat-input-paragraph">
        <p style={{ margin: 0 }}>
          Results Powered by <b>NIET Educator Coaching Hub Online Enhanced Search.</b> &nbsp;
          Enhanced Search generated content can have mistakes. Make sure it's accurate and
          appropriate before using it.
        </p>
      </div>
      <div className="chat-input-input-field">
        <InputField
          value={question}
          onChange={handleOnChange}
          placeholder={
            chatItems?.length > 0
              ? "Enter a follow-up question here"
              : "Ask your question here"
          }
          disableError
          maxLength={10000}
          onKeyDown={handleOnKeyDown}
        />
      </div>
      <div className="chat-input-button-container">
        <ButtonControl type={"okay"} onClick={handleSubmitQuestion}>
          Submit
        </ButtonControl>
        <ButtonControl
          type={"cancel"}
          onClick={handleClearChat}
          disabled={chatItems?.length === 0}
        >
          Clear Chat
        </ButtonControl>
      </div>
    </div>
  );
}
